import { baseRoute } from './smart-alerts/routes'

// These are the routes that are used in multiple components, routes that are only used
// once are in Container.tsx
export const CrmDashboardURL = '/crm'

export const CrmNewNotificationScheduleURL = '/crm/notification-schedules/new'
export const CrmEditNotificationScheduleURL = '/crm/notification-schedules/:uuid'

export const CrmNotificationHistoryURL = '/crm/notification-history'

export const CrmNotificationQueueURL = '/crm/notification-queue'

export const CrmTemplateManagerURL = '/crm/template-manager'

export const CrmSmartAlertsURL = baseRoute
